'use strict';

angular.module('atex.dam').controller('DamTemplateModalController', ['$scope', '$q', '$injector', '$translate',
  'ContentService', 'DamTemplateService', 'AuthenticationService', 'DamNotificationService',
  'DamStoryContentService', 'DamSocialNotificationService',
  'valdr', 'valdrUtil', 'valdrEvents',
function($scope, $q, $injector, $translate,
         ContentService, DamTemplateService, AuthenticationService, DamNotificationService,
         DamStoryContentService, DamSocialNotificationService,
         valdrProvider, valdrUtil, valdrEvents ) {
  $translate(['__OPERATION_COMPLETED_SUCCESSFULLY__']).then(function (translations) {
    $scope.message  = translations.__OPERATION_COMPLETED_SUCCESSFULLY__;
  });

  if ($scope.type === 'atex.dam.standard.Job') {
    $scope.panelTitle = '_TEMPLATE_NEWJOB_PANE_TITLE_';
  } else {
    $scope.panelTitle = '_TEMPLATE_MODAL_PANE_TITLE_';
  }

  $scope.additionalPromises = [];
  $scope.loaded = false;
  $scope.showSpinner = true;

  $scope.viewsStateArray = [];
  $scope.valdError = false;

  $scope.article = atex.Content();

  $scope.article.data.aspects['atex.Metadata'] = {
     data : {
	    _type : 'atex.Metadata',
	    taxonomyIds : ['p.StandardCategorization'],
	    metadata: {
	       _type: "com.polopoly.metadata.Metadata",
	       dimensions:[]
	    }
	 }
  };

  $scope.user = undefined;

  var addHasErrorFn = function(article) {
    if (!article.hasErrors) {
      article.hasErrors = function (view) {
        return atex.dam.ViewUtils.viewHasError(view, $scope.viewsStateArray, $scope.template);
      };
    }
  };

  AuthenticationService.getCurrentUser().then(function(user) {
    var transferInfo = { id: user.userId, variant: 'onecms' };
    ContentService.getContent(transferInfo).then(function(responseInfo) {
      $scope.user = responseInfo.data;
      DamTemplateService.getTemplateByIdAndInputTemplate($scope.type, $scope.inputTemplate).then(function(template){
        $scope.template = angular.copy(template);

        if($scope.jobTemplateId) {
          $scope.template.dataBindings.forEach(function(binding) {
            if(binding.widget === 'pDamJob') {
              binding.config['jobTemplateId'] = $scope.jobTemplateId;
              binding.config['storyContentId'] = $scope.storyContentId;
              binding.config['canBeCancelled'] = $scope.canBeCancelled;
            }
          });
        }

        addHasErrorFn($scope.article);

        DamStoryContentService.job($scope.article, $scope.storyContentId).then(function () {
          $scope.article.template = $scope.template;
          atex.onecms.ObjectUtils.accessor($scope.article.data, 'aspects/atex.OneCMS/data/createdWithTemplate').value = $scope.template.id;
          valdrProvider.setValidation($scope.template);
          $scope.loaded = true;
        });
      });
    });
  });

  $scope.hideSpinner = function() {
    $scope.showSpinner = false;
  };

  $scope.isContentId = function(potentialContentId) {
    return typeof potentialContentId === 'string' && potentialContentId.indexOf('contentid/') === 0;
  };

  function createResource(fieldData, resourceData, i) {
    var promise = ContentService.createContent({
	     data : _.extend({}, resourceData)
	   }).then(function(responseInfo) {

	     fieldData[i] = atex.dam.AngularUtils.addPrefix(responseInfo.id);
	   });
	   $scope.additionalPromises.push(promise);
  }

  function copy(srcMetadata,destMetadata) {
    for (var i=0; i<srcMetadata.metadata.dimensions.length; i++) {
      var entity = {};
      entity['id']=srcMetadata.metadata.dimensions[i].id;
      entity['name']=srcMetadata.metadata.dimensions[i].name;
      entity['entities']=[];

      for (var j=0; j<srcMetadata.metadata.dimensions[i].entities.length; j++) {
        var obj = {};
        obj['attributes']=[];
        obj['entities']=[];
        obj['id']=srcMetadata.metadata.dimensions[i].entities[j].id;
        obj['name']=srcMetadata.metadata.dimensions[i].entities[j].name;

        entity['entities'].push(obj);
      }

      destMetadata.metadata.dimensions.push(entity);
    }
  }

  $scope.$watch("article.local.queryModel", function () {
    if ( $scope.article && $scope.article.local ) {
      var newErrorString = atex.onecms.ObjectUtils.getByPath($scope.article.local, "queryModel/set/errorString");
      var newError = !_.isEmpty(newErrorString);

      if ( newError !== $scope.inError ) {
        $scope.inError = newError;
      }
    }
  }, true);

  var ShapeUtils;

  $scope.doSave = function() {
    $scope.showSpinner = true;

    var fields = $scope.template.dataBindings;

    for (var j = 0; j < fields.length; j++) {
      var field = fields[j];

      if (field.widget === 'pResourceArea') {
        var shortPath = angular.copy(field.path || field.domainObjects.data);
        var path = atex.onecms.ObjectUtils.expandShortPath(shortPath);
        var fieldData = atex.onecms.ObjectUtils.getByPath($scope.article.data.aspects, path);
        if (!fieldData) {
          continue;
        }
        for (var i = 0; i < fieldData.length; i++) {
          var resource = fieldData[i];

          if (!$scope.isContentId(resource)) {
            if (Object.keys(resource.data.aspects.contentData.data).indexOf("thumbnailUrl") !== -1) {
              delete resource.data.aspects.contentData.data.thumbnailUrl;
            }

            // Wrong code, could write StructuredText in String field [max]
            /*
            if (resource.data.aspects.contentData.data.caption !== undefined) {
              resource.data.aspects.contentData.data.caption = $scope.article.data.aspects.contentData.data.headline;
            } else if (resource.data.aspects.contentData.data.headline !== undefined) {
              resource.data.aspects.contentData.data.headline = $scope.article.data.aspects.contentData.data.headline;
            } else if (resource.data.aspects.contentData.data.title !== undefined) {
              resource.data.aspects.contentData.data.title = $scope.article.data.aspects.contentData.data.headline;
            }
            if (resource.data.aspects.contentData.data.description !== undefined) {
              resource.data.aspects.contentData.data.description = $scope.article.data.aspects.contentData.data.body;
            }
            */

            resource.data.aspects['p.InsertionInfo'] = $scope.article.data.aspects['p.InsertionInfo'];
            resource.data.aspects['atex.Metadata'] = {
            		data : {
            	 	    _type : 'atex.Metadata',
            	 	    taxonomyIds : ['p.StandardCategorization'],
            	 	    metadata: {
            	 	       _type: "com.polopoly.metadata.Metadata",
            	 	       dimensions:[]
            	 	    }
            	 	 }
            };
            copy( $scope.article.data.aspects['atex.Metadata'].data, resource.data.aspects['atex.Metadata'].data );
            createResource(fieldData, resource.data, i);
          }
        }
      }
    }

    var processCreatePageResults = function ( data ) {
      var message = $scope.message;
      var messageType = 'success';

      if ( data && data.data && data.data.status ) {

        if ( !_.isEmpty( data.data.status.strErrorText ) ) {
          message = data.data.status.strErrorText;
        }

        if ( data.data.status.lErrorCode > 0 ) {
           messageType = 'error';
        }
      }

      $scope.showSpinner = false;
      $scope.$parent.closeModal();
      DamNotificationService.addNotification(atex.dam.Notification({ type: messageType, message: message }), false);
    };

    var processCreatePageError = function (error) {
      $scope.showSpinner = false;
    };

    if ( $scope.article.local && $scope.article.local.shapesObj ) {

      if ( !ShapeUtils ) {
        ShapeUtils = $injector.get("ShapeUtils");
      }

      var shapesObj = $scope.article.local.shapesObj;

      if ( shapesObj.shapeMode  === ShapeUtils.CREATE_PAGE_SELECT || shapesObj.shapeMode  === ShapeUtils.BUILD_FULL_BOOK ) {
        shapesObj.createPage( $scope.article.local.queryModel ).then(function (data) {
          processCreatePageResults(data);
        }).then(undefined, function (error) {
          processCreatePageError(error);
        });
      }

      return;
    }

    var contentData = atex.onecms.ObjectUtils.getByPath($scope.article.data.aspects, 'contentData');
    if (!contentData) {
      $scope.showSpinner = false;
      return;
    }
    return $q.all($scope.additionalPromises).then(function() {
      var json = angular.toJson($scope.article.data);
      var cleanData = angular.fromJson(json);
      var transferInfo = {
        data: cleanData
      };
      return ContentService.createContent(transferInfo);
    }).then(function(response) {
      $scope.showSpinner = false;
      $scope.$parent.closeModal();
      DamNotificationService.addNotification(atex.dam.Notification({ type: 'success', message: $scope.message }), false);

      var type = atex.onecms.ObjectUtils.getByPath($scope.article, 'data/aspects/contentData/data/_type') || "";
      DamSocialNotificationService.sendMessage(response.id, type);

      $scope.$broadcast("dam:savedItem", response.id);
    }).then(null, function(error) {
      $scope.showSpinner = false;
      var msg = error && error.cause ? error.cause : "Generic Error";
      DamNotificationService.addNotification(atex.dam.Notification({ type: 'error', message: msg }), true);
    });
  };

  $scope.changeEndCallback = function(data) {
    $scope.article.data = data;
    $scope.dirty = true;
  };

  $scope.initCallback = function() {
    // console.log("INFO: Current Template id: " + $scope.article.template.id);
    var check = false;
    if ($scope.template.type) {
      check = valdrUtil.has(valdrProvider.getConstraints(), $scope.template.type);
    }
    return check;
  };

  $scope.$on(valdrEvents.validated, function(event) {
    if (!$scope.myForm.$valid) {
      $scope.valdError = atex.dam.ViewUtils.checkViewStateArray($scope.viewsStateArray, event);
    } else {
      $scope.valdError = false;
    }
  });

  $scope.changeStartCallback = function() {
  };

  var selectFirstWorkingSite = function(workingSites, selectedAssociatedSites, selectedTaxonomyIds) {
    if (typeof workingSites !== 'undefined' && workingSites.length > 0) {
      return ContentService.getContent({ id: 'externalid/' + workingSites[0].id }).then(function(responseInfo) {
        var externalIdAlias = atex.onecms.ObjectUtils.getByPath(responseInfo, 'data/aspects/atex.Aliases/data/aliases/externalId');

        selectedTaxonomyIds.push(externalIdAlias);

        var oldTypeContentId = 'contentid/' + responseInfo.id.substring(responseInfo.id.indexOf(':') + 1);

        selectedAssociatedSites.push(oldTypeContentId);
      });
    }

    return $q.when();
  };

  $scope.prepareEdit = function(topDomainObject) {
    var taxonomyIdsDomainObject = atex.onecms.DomainObjectUtils.getDomainObjectByPath(topDomainObject, 'aspects/atex.Metadata/data/taxonomyIds');
    var associatedSitesDomainObject = atex.onecms.DomainObjectUtils.getDomainObjectByPath(topDomainObject, 'aspects/p.InsertionInfo/data/associatedSites');

    var skipSetFirstWorkingSite = true; // Avoid set as associated site a random first working Site [max]
    if (!skipSetFirstWorkingSite && typeof taxonomyIdsDomainObject !== 'undefined' && typeof associatedSitesDomainObject !== 'undefined') {
      var selectedAssociatedSites = [];
      var selectedTaxonomyIds = [];

      var workingSites = atex.onecms.ObjectUtils.getByPath($scope.user, 'aspects/contentData/data/workingSites');

      var selectionPromise = selectFirstWorkingSite(workingSites, selectedAssociatedSites, selectedTaxonomyIds);

      return selectionPromise.then(function() {
        selectedAssociatedSites.forEach(function(site) {
          associatedSitesDomainObject.add(site);
        });

        selectedTaxonomyIds.forEach(function(taxonomyId) {
          taxonomyIdsDomainObject.add(taxonomyId);
        });

        topDomainObject.changed(); // clear any dirty-state...
      }).then(undefined, function(error) {
        var errorMessage = (typeof error !== 'undefined' && typeof error.cause !== 'undefined') ? error.cause : 'unknown error';

        var wrappedError = atex.onecms.error.Error({
          rootCause: error,
          severity: atex.onecms.error.severities.NORMAL,
          origin: 'Contributor Tool Detail View Controller',
          cause: 'Error while preparing content for editing: ' + errorMessage
        });

        console.warn(wrappedError);
      });
    }
    else {
      return $q.when();
    }
  };

} ]);
